(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
  class ViewportScroll extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.startValue = parseFloat(this.getAttribute('data-start')) || 0;
      this.endValue = parseFloat(this.getAttribute('data-end')) || 0;
      this.style.setProperty('--offset-length', `${this.startValue}px`);
      window.addEventListener('scroll', this.updateParallaxEffect.bind(this));
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.updateParallaxEffect.bind(this));
    }

    updateParallaxEffect() {
      const rect = this.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const elementMiddle = rect.top + rect.height / 2;
      const progress = Math.min(
        Math.max((viewportHeight - elementMiddle) / viewportHeight, 0),
        1
      );
      const currentValue = this.startValue + progress * (this.endValue - this.startValue);
      const clampedValue = Math.max(
        Math.min(currentValue, Math.max(this.startValue, this.endValue)),
        Math.min(this.startValue, this.endValue)
      );
      this.style.setProperty('--offset-length', `${clampedValue}px`);
    }
  }
  if (!customElements.get('viewport-scroll')) { customElements.define('viewport-scroll', ViewportScroll);}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  class SmoothAnchor extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback(){
      this.anchor = this.querySelector('a');
      this.anchor.addEventListener('click', this.onClickRef.bind(this));
    }
    
    onClickRef(){
      event.preventDefault();
      const targetId = this.anchor.getAttribute('href');
      const targetElement = document.querySelector(targetId);

      if(targetElement){
        if(this.dataset.offset){
          let offset = 0;
          const offsetElement = document.querySelector(this.dataset.offset);
          if(!offsetElement){
            doScroll();
            if(targetElement.nodeName.toLowerCase() === 'input') targetElement.focus();
            return
          };
          const elementPosition = targetElement.getBoundingClientRect().top;
          offset = elementPosition + window.scrollY - offsetElement.offsetHeight;
          window.scrollTo({
            top: offset,
            behavior: "smooth"
          });
          if(targetElement.nodeName.toLowerCase() === 'input') targetElement.focus();
          return;
        }
        doScroll();
        if(targetElement.nodeName.toLowerCase() === 'input') targetElement.focus();
      }
        
      function doScroll(){
        targetElement.scrollIntoView({
          behavior: "smooth"
        });
      }
    }
  }
  if(!customElements.get('smooth-anchor')) customElements.define('smooth-anchor', SmoothAnchor);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-scroll-with-tabs"] && !Shopify.designMode) return;
  try {
    
  class ScrollAnimator extends HTMLElement {
  constructor() {
    super();

    if(screen.width < 768) return;
    this.parent = this;
    this.animations = [];
    this.handleScroll = this.handleScroll.bind(this);
  }

  connectedCallback() {
    if(screen.width < 768) return;
    window.addEventListener('scroll', this.handleScroll);
    requestAnimationFrame(() => this.handleScroll());
    this.initialize();
  }

  initialize(){
      // scroll to tab 1
      // this.tab1End = this.querySelector('.nav-items li:first-child').dataset.end;
      // this.scrollTo(this.tab1End);
      const bodyWidth = document.body.clientWidth;
      this
        .animate('.bar1', { start: 8, end: 16, points: { to: { scale: 14, x: -1 * (bodyWidth - document.querySelector('.main .bar1').clientWidth) }} })
        .animate('.bar2', { start: 8, end: 16, points: { to: { scale: 14, } } })
        .animate('.bar3', { start: 8, end: 16, points: { to: { scale: 14, x: (bodyWidth - document.querySelector('.main .bar3').clientWidth) }} })
        .animate('.bar2', { start: 32, points: { from: { opacity: 1 }, to: { opacity: 0 }} })
        .animate('.images', { start: 14, end: 30, points: { from: { y: window.innerHeight, x: -1 * (document.body.clientWidth - document.querySelector('.images').clientWidth) }, to: { y: 0, x: -1 * (document.body.clientWidth - document.querySelector('.images').clientWidth) } } })
        .animate('.images', { start: 35, end: 50, points: { from: { x: -1 * (document.body.clientWidth - document.querySelector('.images').clientWidth) }, to: { x: 0 } } })
        .animate('.images .image:first-child', { start: 55, end: 60, points: { from: { scale: 1 }, to: { scale: 1.1, } } })
        .animate('.img2', { start: 14, end: 30, points: { from: { y: window.innerHeight + 400 }, to: { y: 0 } } })
        .animate('.img2', { start: 36, end: 55, points: { from: { x: 0 }, to: { x: document.body.clientWidth - (isNaN(document.querySelector('.img2').width) ? document.querySelector('.img2').getBoundingClientRect().width : document.querySelector('.img2').width) } } })
        .animate('.img3', { start: 14, end: 30, points: { from: { y: window.innerHeight + 800 }, to: { y: 0 } } })
        .animate('.img3', { start: 38, end: 60, points: { from: { x: 0 }, to: { x: document.body.clientWidth - (isNaN(document.querySelector('.img2').width) ? document.querySelector('.img2').getBoundingClientRect().width : document.querySelector('.img2').width) } } })
        .animate('.nav-items', { start: 48, points: { from: { opacity: 0 }, to: { opacity: 1 } } })
        .animate('.nav-items li:first-child', { start: 48, end: 57, classNames: { add: 'active' } })
        .animate('.item-content:first-child', { start: 48, end: 57, points: { from: { opacity: 0, y: 30 }, to: { opacity: 1, y: 0 } } })


      this.querySelectorAll('.text-wrapper .item-content').forEach((content, ind) => {
          let start = (ind * 7) + 50;
          let end = start + 7;

          if (ind !== 0 && ind != (document.querySelectorAll('.text-wrapper .item-content').length - 1)) {
              this.animate('.' + content.classList[1], { start: start, end: end, points: { from: { opacity: 0, y: 30 }, to: { opacity: 1, y: 0 } } });
          }
          if (ind == (document.querySelectorAll('.text-wrapper .item-content').length - 1)) {
              this.animate('.' + content.classList[1], { start: start, points: { from: { opacity: 0, y: 30 }, to: { opacity: 1, y: 0 } } });
          }
      });

      this.querySelectorAll('.nav-items li').forEach((item, ind) => {
          let start = (ind * 7) + 50;
          let end = start + 7;

          if (ind !== 0 && ind != (document.querySelectorAll('.nav-items li').length - 1)) {
              this.animate('.' + item.classList[1], { start: start, end: end, classNames: { add: 'active' } });
          }
          if (ind == (document.querySelectorAll('.nav-items li').length - 1)) {
              this.animate('.' + item.classList[1], { start: start, classNames: { add: 'active' } });
          }

          item.querySelector('a').addEventListener('click', (e) => {
              e.preventDefault();
              this.scrollTo(end);
          });

          if (this.dataset.goTo !== 'true'){
            item.querySelector('a').addEventListener('focusin', (e) => {
                e.preventDefault();
                this.scrollTo(end);
            });
          }
      });

      this.querySelectorAll('.images .image').forEach((img, ind) => {
          // let start = ((ind - 1) * 7) + 55;
          let start = ((ind) * 7) + 50;
          let end = start + 7;

          if (ind !== 0) {
              this.animate('.' + img.classList[1], { start: start, end: end, points: { from: { y: window.innerHeight }, to: { y: 0 } } })
          }
          if (ind !== 0 && ind !== (document.querySelectorAll('.nav-items li').length - 1)) {
              this.animate('.' + img.classList[1], { start: end, end: (end + 5), points: { from: { scale: 1 }, to: { scale: 1.1, } } })
          }
      });

      if (this.dataset.goTo === 'true'){
          document.addEventListener('shopify:block:select', (event) => {
            const element = event.target;
            const elementEnd = element.previousElementSibling;
            this.scrollTo(element.dataset.end ? element.dataset.end : (parseInt(element.dataset.start) + 7));
          });
        }

      if (this.dataset.goTo === 'true'){
        document.addEventListener('shopify:section:select', (event) => {
          const target = event.target;
          if(!target.classList.contains('includes-scroll-animator')) return;
          const element = document.querySelector('.nav-items li');
          this.scrollTo(parseInt(element.dataset.start) + 7);
        });
      }
      this.classList.remove('scroll-animator--loading');
    }

  animate(target, { start, end, points, classNames, transformOrigin }) {
      const elements = document.querySelectorAll(target);
      if (!elements.length) return this;

      elements.forEach(element => {
          if (!element.dataset.transforms) {
              element.dataset.transforms = JSON.stringify({});
          }

          const computedStyle = window.getComputedStyle(element);
          let initialTransforms = this._parseTransform(computedStyle.transform);

          let fromProps = points?.from || {};
          let toProps = points?.to || {};

          Object.keys(toProps).forEach(key => {
              if (!(key in fromProps)) {
                  fromProps[key] = initialTransforms[key] || (key === 'scale' ? 1 : 0);
              }
          });

          Object.keys(fromProps).forEach(key => {
              if (!(key in toProps)) {
                  toProps[key] = initialTransforms[key] || (key === 'scale' ? 1 : 0);
              }
          });

          this.animations.push({ element, start, end, fromProps, toProps, classNames, transformOrigin });

          element.classList.add('scroll-item');

          if (start) { element.dataset.start = start }
          if (end) { element.dataset.end = end }
      });

      return this;
  }

  handleScroll() {
      const sectionRect = this.parent.getBoundingClientRect();
      const sectionHeight = this.parent.offsetHeight;
      const viewportHeight = window.innerHeight;

      if (sectionRect.top > viewportHeight || sectionRect.bottom < 0) return;

      const scrollProgress = ((viewportHeight - sectionRect.top) / (sectionHeight + viewportHeight)) * 100;

      this.animations.forEach(({ element, start, end, fromProps, toProps, classNames, transformOrigin }) => {
          let progress = (scrollProgress - start) / (end - start || 1);
          progress = Math.max(0, Math.min(1, progress));

          let transformValues = JSON.parse(element.dataset.transforms);
          let opacityValue = null;

          Object.keys(toProps).forEach(key => {
              let fromValue = fromProps[key];
              let toValue = toProps[key];
              let value = fromValue + (toValue - fromValue) * progress;

              if (key === 'x') transformValues.translateX = `${value}px`;
              if (key === 'y') transformValues.translateY = `${value}px`;
              if (key === 'rotate') transformValues.rotate = `${value}deg`;
              if (key === 'scale') transformValues.scale = value;
              if (key === 'opacity') opacityValue = value;
          });

          // Handle opacity reset when scrolling past the end point
          if (opacityValue !== null) {
              if (scrollProgress > end) {
                  element.style.opacity = fromProps.opacity ?? 1; // Reset to initial
              } else {
                  element.style.opacity = opacityValue;
              }
          }

          element.dataset.transforms = JSON.stringify(transformValues);

          let transformString = Object.entries(transformValues)
              .map(([key, val]) => `${key}(${val})`)
              .join(' ');

          if (transformString) {
              element.style.transform = transformString;
          }

          // Apply transform-origin if specified
          if (transformOrigin) {
              element.style.transformOrigin = transformOrigin;
          }

          // Handle class toggling
          if (classNames) {
              if (scrollProgress >= start) {
                  if (classNames.add) element.classList.add(classNames.add);
                  if (classNames.remove) element.classList.remove(classNames.remove);
              }
              if (scrollProgress < start) {
                  if (classNames.add) element.classList.remove(classNames.add);
              }
              if (end && scrollProgress > end) {
                  if (classNames.add) element.classList.remove(classNames.add);
              }
          }
      });
  }

  _parseTransform(transform) {
      let values = { translateX: 0, translateY: 0, scale: 1, rotate: 0 };

      if (!transform || transform === 'none') return values;

      let matches = transform.match(/(\w+)\(([^)]+)\)/g);
      if (!matches) return values;

      matches.forEach(match => {
          let [type, val] = match.split('(');
          val = val.replace(')', '').split(',').map(v => parseFloat(v.trim()));

          if (type === 'translateX') values.translateX = val[0] || 0;
          if (type === 'translateY') values.translateY = val[0] || 0;
          if (type === 'scale') values.scale = val[0] || 1;
          if (type === 'rotate') values.rotate = val[0] || 0;
      });

      return values;
  }

  // Use scrollTo(num) scroll to specific section percentage.
  scrollTo(percentage = 0) {
      if (percentage < 0 || percentage > 100) return;

      const sectionHeight = this.parent.offsetHeight;
      const viewportHeight = window.innerHeight;
      const sectionTop = this.parent.offsetTop;

      // Calculate exact scroll position in the document
      const targetScroll = sectionTop + ((sectionHeight + viewportHeight) * percentage) / 100 - viewportHeight;

      window.scrollTo({
          top: targetScroll,
          behavior: 'smooth',
      });

      // Ensure animation updates immediately
      requestAnimationFrame(() => this.handleScroll());
  }
}
if (!customElements.get('scroll-animator')) customElements.define('scroll-animator', ScrollAnimator);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vog-footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    let apiReady;
    let opener;
    function privacyApi() {
      if (window.Shopify && window.Shopify.customerPrivacy &&
          typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function') {
        return Promise.resolve(window.Shopify.customerPrivacy);
      }
      if (!apiReady) {
        apiReady = new Promise((resolve, reject) => {
          if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
            reject(new Error('Customer Privacy API is unavailable'));
            return;
          }
          window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], (error) => {
            if (error || !window.Shopify.customerPrivacy) {
              reject(error || new Error('Customer Privacy API could not load'));
              return;
            }
            resolve(window.Shopify.customerPrivacy);
          });
        }).catch((error) => { apiReady = undefined; throw error; });
      }
      return apiReady;
    }
    function fillChoices(dialog, api) {
      const consent = api.currentVisitorConsent();
      const allowed = {
        analytics: api.analyticsProcessingAllowed(),
        marketing: api.marketingAllowed(),
        preferences: api.preferencesProcessingAllowed()
      };
      ['analytics', 'marketing', 'preferences'].forEach((key) => {
        dialog.querySelector('input[name="' + key + '"]').checked =
          consent[key] === 'yes' || (consent[key] !== 'no' && allowed[key]);
      });
    }
    async function saveChoices(dialog, rejectOptional) {
      const result = dialog.querySelector('[data-vog-cookie-result]');
      const buttons = dialog.querySelectorAll('button');
      buttons.forEach((button) => { button.disabled = true; });
      result.textContent = 'Saving your choices…';
      try {
        const api = await privacyApi();
        const choices = {};
        ['analytics', 'marketing', 'preferences'].forEach((key) => {
          choices[key] = !rejectOptional && dialog.querySelector('input[name="' + key + '"]').checked;
        });
        await new Promise((resolve, reject) => {
          api.setTrackingConsent(choices, (response) => {
            if (response && response.error) reject(new Error('Consent could not be saved'));
            else resolve();
          });
        });
        const saved = api.currentVisitorConsent();
        if (Object.keys(choices).some((key) => saved[key] !== (choices[key] ? 'yes' : 'no'))) {
          throw new Error('Consent has not been confirmed');
        }
        fillChoices(dialog, api);
        result.textContent = 'Your choices have been saved.';
        dialog.close();
        if (opener) {
          opener.focus();
          const status = opener.parentElement.querySelector('[data-vog-cookie-status]');
          if (status) { status.textContent = 'Your cookie preferences have been saved.'; status.hidden = false; }
        }
      } catch (error) {
        result.textContent = 'We could not save your choices. Please try again or contact info@thevirtueofgodbrand.com.';
      } finally {
        buttons.forEach((button) => { button.disabled = false; });
      }
    }
    document.addEventListener('click', async (event) => {
      if (!(event.target instanceof Element)) return;
      const button = event.target.closest('[data-vog-cookie-preferences]');
      if (button) {
        const dialog = document.querySelector('[data-vog-cookie-dialog]');
        const status = button.parentElement.querySelector('[data-vog-cookie-status]');
        if (!dialog || button.disabled) return;
        button.disabled = true;
        if (status) status.hidden = true;
        try {
          const api = await privacyApi();
          fillChoices(dialog, api);
          dialog.querySelector('[data-vog-cookie-result]').textContent = '';
          opener = button;
          if (!dialog.open) dialog.showModal();
          dialog.querySelector('h2').focus();
        } catch (error) {
          if (status) { status.textContent = 'Cookie settings could not open. Please reload the page and try again.'; status.hidden = false; }
        } finally { button.disabled = false; }
      }
      const dialog = event.target.closest('[data-vog-cookie-dialog]');
      if (!dialog) return;
      if (event.target.closest('[data-vog-cookie-close]')) { dialog.close(); if (opener) opener.focus(); }
      if (event.target.closest('[data-vog-cookie-reject]')) await saveChoices(dialog, true);
    });
    document.addEventListener('submit', async (event) => {
      if (!(event.target instanceof HTMLFormElement) || !event.target.matches('[data-vog-cookie-form]')) return;
      event.preventDefault();
      await saveChoices(event.target.closest('[data-vog-cookie-dialog]'), false);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
